import { toFixed } from '../../../utils/number-utils';
import adjustments from '../../../constants/adjustments';

const FIXED_TYPE = 'fixed';

export const isFixed = (type) => type === FIXED_TYPE;

export const calculatePositiveAdjustment = (price, rate, type) => {
  if (!rate || !type) return toFixed(price);

  const parsedPrice = parseFloat(price);
  const parsedRate = parseFloat(rate);

  if (isFixed(type)) {
    return toFixed(parsedPrice + parsedRate);
  } else {
    return toFixed(parsedPrice * (1 + parsedRate / 100));
  }
};

const calculateNegativeAdjustment = (price, rate, type) => {
  if (!rate || !type) return toFixed(price);

  const parsedPrice = parseFloat(price);
  const parsedRate = parseFloat(rate);

  if (isFixed(type)) {
    return toFixed(parsedPrice - parsedRate);
  } else {
    return toFixed(parsedPrice * (1 - parsedRate / 100));
  }
};

export const calculateFinalPriceByAdjustments = (price, listOfAdjustments = []) => {
  if (!listOfAdjustments?.length) return toFixed(price);

  let finalPrice = price;

  for (var adjustment of listOfAdjustments) {
    const { value, valueType, condition } = adjustment;
    const calculationFunction =
      condition === adjustments.CONDITIONS.NEGATIVE ? calculateNegativeAdjustment : calculatePositiveAdjustment;

    finalPrice = calculationFunction(finalPrice, value, valueType);
  }

  return finalPrice;
};
